import { render, staticRenderFns } from "./CSearchResult.vue?vue&type=template&id=287ad48f&scoped=true"
import script from "./CSearchResult.vue?vue&type=script&lang=ts"
export * from "./CSearchResult.vue?vue&type=script&lang=ts"
import style0 from "./CSearchResult.vue?vue&type=style&index=0&id=287ad48f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@babel+core@8.0.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack_3967ed8cd784b60b7f0fd1a71945913e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287ad48f",
  null
  
)

export default component.exports